@use '@design/design-tokens/typography/typography' as *;

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
}

.title {
  @include typography-v2-title-base;
}

.message {
  @include typography-v2-body-sm;

  color: var(--text-soft);
  margin: 4px 0 16px;
}
